import React from "react";
import {BookOpenIcon, LightbulbIcon} from "lucide-react";
import {STEP_HELP, StepKey} from "../stepHelpContent";

export default function HelpSidebar({step}: { step: StepKey }) {
    const content = STEP_HELP[step];
    if (!content) return null;

    return (
        <aside className="sticky top-6 max-h-[calc(100vh-8rem)] overflow-y-auto rounded-xl border border-gray-200 bg-gray-50">
            <div className="p-4 border-b border-gray-200">
                <div className="flex items-center gap-2 mb-2">
                    <BookOpenIcon className="size-4 text-orange-500 shrink-0"/>
                    <span className="text-xs font-semibold text-orange-700 uppercase tracking-wide">
                        Step Guide
                    </span>
                </div>
                <p className="text-xs text-gray-600 leading-relaxed">{content.overview}</p>
            </div>

            <div className="p-3 space-y-2">
                {content.fields.map((item) => (
                    <div
                        key={item.field}
                        className="rounded-lg border border-gray-200 bg-white p-3 shadow-sm"
                    >
                        <p className="text-xs font-semibold text-orange-700 mb-1">{item.field}</p>
                        <p className="text-xs text-gray-600 leading-relaxed">{item.description}</p>
                        {item.tips && item.tips.length > 0 && (
                            <ul className="mt-2 space-y-1">
                                {item.tips.map((tip, i) => (
                                    <li key={i} className="flex items-start gap-1.5">
                                        <LightbulbIcon className="size-3 text-amber-400 shrink-0 mt-0.5"/>
                                        <span className="text-xs text-gray-500 leading-relaxed">{tip}</span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                ))}
            </div>
        </aside>
    );
}
